// | Wrapper around Map providing Decode and Encode instances.
// |
// | The wire format depends on the `AsJSONKey` instance for the key. See Aeson documentation for details.
import * as $runtime from "../runtime.js";
import * as Control$dMonad$dExcept$dTrans from "../Control.Monad.Except.Trans/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunction from "../Data.Function/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dNonEmpty from "../Data.NonEmpty/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dTraversable from "../Data.Traversable/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dTuple$dT2 from "../Data.Tuple.T2/index.js";
import * as Data$dUnfoldable from "../Data.Unfoldable/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Foreign$dObject from "../Foreign.Object/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const $AsJSONKeyFunction = (tag, _1, _2) => ({tag, _1, _2});
const SerializedMap = x => x;
const AsJSONKeyString = value0 => value1 => $AsJSONKeyFunction("AsJSONKeyString", value0, value1);
const AsJSONKeyValue = value0 => value1 => $AsJSONKeyFunction("AsJSONKeyValue", value0, value1);
const asJSONKeyMaybe = dictEncode => dictDecode => (
  {
    asJSONKey: $AsJSONKeyFunction(
      "AsJSONKeyValue",
      v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return dictEncode.encode(v2._1); }
        $runtime.fail();
      },
      Foreign$dNullOrUndefined.readNullOrUndefined(dictDecode.decode)
    )
  }
);
const asJSONKeyInt = {
  asJSONKey: /* #__PURE__ */ $AsJSONKeyFunction(
    "AsJSONKeyString",
    Data$dShow.showIntImpl,
    /* #__PURE__ */ (() => {
      const $0 = Control$dMonad$dExcept$dTrans.monadThrowExceptT(Data$dIdentity.monadIdentity).throwError;
      const $1 = Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity).pure;
      return x => {
        const $2 = Data$dInt.fromString(x);
        if ($2.tag === "Nothing") { return $0(Data$dNonEmpty.$NonEmpty(Foreign.$ForeignError("ForeignError", "Invalid Int"), Data$dList$dTypes.Nil)); }
        if ($2.tag === "Just") { return $1($2._1); }
        $runtime.fail();
      };
    })()
  )
};
const udecodeMap = dictOrd => dictFromJSONKey => dictDecode => Unscramble.decodeMap(dictFromJSONKey)(dictOrd)(dictDecode);
const showMap = dictShow => dictShow1 => Data$dMap$dInternal.showMap(dictShow)(dictShow1);
const semigroupMap = dictOrd => ({append: v => v1 => Data$dMap$dInternal.unionWith(dictOrd)(Data$dFunction.const)(v)(v1)});
const ordMap = dictOrd => dictOrd1 => Data$dMap$dInternal.ordMap(dictOrd)(dictOrd1);
const newtypeMap = {Coercible0: () => {}};
const monoidMap = dictOrd => ({mempty: Data$dMap$dInternal.Leaf, Semigroup0: () => ({append: v => v1 => Data$dMap$dInternal.unionWith(dictOrd)(Data$dFunction.const)(v)(v1)})});
const functorMap = Data$dMap$dInternal.functorMap;
const fromSerializedMap = Unsafe$dCoerce.unsafeCoerce;
const fromJSONKeyMap = dictOrd => dictFromJSONKey => dictDecode => (
  {fromJSONKey: Unscramble.$FromJSONKeyFunction("FromJSONKeyValue", Unscramble.decodeMap(dictFromJSONKey)(dictOrd)(dictDecode).unsafeDecode)}
);
const foldableWithIndexMap = Data$dMap$dInternal.foldableWithIndexMap;
const foldableMap = Data$dMap$dInternal.foldableMap;
const eqMap = dictEq => dictEq1 => Data$dMap$dInternal.eqMap(dictEq)(dictEq1);
const asJSONKeyString = /* #__PURE__ */ (() => (
  {asJSONKey: $AsJSONKeyFunction("AsJSONKeyString", x => x, Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity).pure)}
))();
const asJSONKeyMap = dictOrd => dictAsJSONKey => dictEncode => dictDecode => ({asJSONKey: $AsJSONKeyFunction("AsJSONKeyValue", dictEncode.encode, dictDecode.decode)});
const asJSONKey = dict => dict.asJSONKey;
const decodeMap = dictOrd => dictAsJSONKey => dictDecode => dictGenericDecodeArgs => (
  {
    decode: f => {
      if (dictAsJSONKey.asJSONKey.tag === "AsJSONKeyString") {
        return Control$dMonad$dExcept$dTrans.bindExceptT(Data$dIdentity.monadIdentity).bind(Foreign$dGeneric$dClass.objectDecode(dictDecode).decode(f))(obj => {
          const $0 = Data$dMap$dInternal.fromFoldable(dictOrd)(Data$dFoldable.foldableArray);
          const $1 = Data$dTraversable.traversableArray.traverse(Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity))(v1 => {
            const $1 = dictAsJSONKey.asJSONKey._2(v1._1);
            if ($1.tag === "Left") { return Data$dEither.$Either("Left", $1._1); }
            if ($1.tag === "Right") { return Data$dEither.$Either("Right", Data$dTuple.$Tuple($1._1, v1._2)); }
            $runtime.fail();
          })(Data$dArray.toUnfoldable(Data$dUnfoldable.unfoldableArray)(Foreign$dObject.toArrayWithKey(Data$dTuple.Tuple)(obj)));
          if ($1.tag === "Left") { return Data$dEither.$Either("Left", $1._1); }
          if ($1.tag === "Right") { return Data$dEither.$Either("Right", $0($1._1)); }
          $runtime.fail();
        });
      }
      if (dictAsJSONKey.asJSONKey.tag === "AsJSONKeyValue") {
        return Control$dMonad$dExcept$dTrans.bindExceptT(Data$dIdentity.monadIdentity).bind(Foreign$dGeneric$dClass.arrayDecode(Data$dTuple$dT2.decodeT2({
          decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Foreign$dGeneric$dClass.foreignDecode.decode}),
          decodeSingleRecordArg: Data$dMaybe.Nothing
        })(dictGenericDecodeArgs)).decode(f))(kvs => {
          const $0 = Data$dMap$dInternal.fromFoldable(dictOrd)(Data$dFoldable.foldableArray);
          const $1 = Data$dTraversable.traversableArray.traverse(Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity))(v1 => {
            const $1 = dictAsJSONKey.asJSONKey._2(v1._1);
            if ($1.tag === "Left") { return Data$dEither.$Either("Left", $1._1); }
            if ($1.tag === "Right") { return Data$dEither.$Either("Right", Data$dTuple.$Tuple($1._1, v1._2)); }
            $runtime.fail();
          })(kvs);
          if ($1.tag === "Left") { return Data$dEither.$Either("Left", $1._1); }
          if ($1.tag === "Right") { return Data$dEither.$Either("Right", $0($1._1)); }
          $runtime.fail();
        });
      }
      $runtime.fail();
    }
  }
);
const encodeMap = dictAsJSONKey => dictEncode => dictGenericEncodeArgs => (
  {
    encode: v => {
      const kvs = Data$dMap$dInternal.toUnfoldable(Data$dUnfoldable.unfoldableArray)(v);
      if (dictAsJSONKey.asJSONKey.tag === "AsJSONKeyString") {
        return Foreign$dObject._mapWithKey(
          Foreign$dObject.fromFoldable(Data$dFoldable.foldableArray)(Data$dFunctor.arrayMap(v2 => Data$dTuple.$Tuple(dictAsJSONKey.asJSONKey._1(v2._1), v2._2))(kvs)),
          v$1 => dictEncode.encode
        );
      }
      if (dictAsJSONKey.asJSONKey.tag === "AsJSONKeyValue") {
        return Data$dFunctor.arrayMap(Data$dTuple$dT2.encodeT2({
          encodeArgs: opts => v$1 => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v$1), Data$dList$dTypes.Nil)
        })(dictGenericEncodeArgs).encode)(Data$dFunctor.arrayMap(v2 => Data$dTuple$dT2.$T2(dictAsJSONKey.asJSONKey._1(v2._1), v2._2))(kvs));
      }
      $runtime.fail();
    }
  }
);
export {
  $AsJSONKeyFunction,
  AsJSONKeyString,
  AsJSONKeyValue,
  SerializedMap,
  asJSONKey,
  asJSONKeyInt,
  asJSONKeyMap,
  asJSONKeyMaybe,
  asJSONKeyString,
  decodeMap,
  encodeMap,
  eqMap,
  foldableMap,
  foldableWithIndexMap,
  fromJSONKeyMap,
  fromSerializedMap,
  functorMap,
  monoidMap,
  newtypeMap,
  ordMap,
  semigroupMap,
  showMap,
  udecodeMap
};
